export enum PaymentType {
  EFT = 1,
  OnceOffCollection = 2
}